module.exports = __webpack_public_path__ + "static_1782371361332/img/timg.c977239a.gif";